'use client'

import React, { useEffect } from "react";
import { UserContextProvider } from "./useUserContext";
import { NotificationProvider } from "@/components/PushNotification/NotificationProvider";
import { ChatProvider } from "@/components/Chat/ChatProvider";
import { AdminSupportChatProvider } from "@/components/Chat/AdminSupportChatProvider";

export const AppProviders = ({ children }: { children: React.ReactNode }) => {
  return (
      <UserContextProvider>
        <NotificationProvider>
          <AdminSupportChatProvider>
            <ChatProvider>
              {children}
            </ChatProvider>
          </AdminSupportChatProvider>
        </NotificationProvider>
      </UserContextProvider>
  );
};
